import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import increaseColorPointByStep from '../../../../../common/utils/increase-color-point-by-step';

const dark = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, darkColorPalette } = params;
  const fallback = {
    rule: 'filePicker.button.border.default.dark',
    params,
  };
  if (contrastRatio(backgroundColor, darkColorPalette[50]) >= 1.7) {
    return increaseColorPointByStep({
      targetColor,
      targetColorPalette,
      step: 1,
      fallback,
    });
  }

  const { hue, saturation, lightness, alpha } = targetColor;
  return new HSLColor(hue, saturation, lightness, alpha);
};
export default dark;
